<template>
  <transition name="full-slide-up">
    <VCard :radiusArray="[15, 15, 0, 0]" class="card-wrapper">
      <VBlock :direction="Direction.column">
        <VBlock :sort="Sort.space_between" class="card-text">
          <VSpan :text="`선택한 상품권 (${selectedGiftCards.length}개)`" :size="16" />
          <VSpan :text="`${totalGiftCardsPrices.toLocaleString()}원`" :size="16" />
        </VBlock>
        <VBlock :sort="Sort.space_between" class="card-text">
          <VSpan text="사용 예정 금액" :size="16" />
          <VSpan :text="`-${totalGiftCardsSelectedPrices.toLocaleString()}원`" :size="16" />
        </VBlock>
        <VBlock :sort="Sort.space_between" class="card-text">
          <VSpan text="사용 후 잔액" :size="16" />
          <VSpan
            :text="`${(totalGiftCardsPrices - totalGiftCardsSelectedPrices).toLocaleString()}원`"
            :size="16"
          />
        </VBlock>
      </VBlock>
      <VButton
        class="bottom-button"
        :radius="4"
        :color="ButtonColor.brand"
        :onClick="() => validate()"
      >
        <VSpan
          :text="`${totalGiftCardsSelectedPrices.toLocaleString()}원 사용하기`"
          :size="18"
          :color="TextColor.white"
          :weight="TextWeight.bold"
        />
      </VButton>
    </VCard>
  </transition>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard, { ColorType } from '@/presentationals/v2/components/layouts/molecules/VCard'

export default {
  name: 'PreOrderGiftSelection',
  props: {
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    selectedGiftCards: Array,
    totalGiftCardsPrices: Number,
    totalGiftCardsSelectedPrices: Number,
    isNotValid: Boolean,
    validate: {
      type: Function,
      required: true
    }
  },
  components: {
    VSpan,
    VButton,
    VBlock,
    VCard
  },
  computed: {},

  destroyed() {
    this.onCancel()
  },
  methods: {},
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,

      ColorType
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';
.bottom-button {
  width: calc(100% + 10px);
  margin: 0px -5px;
  padding: 15px 20px 14px 20px;
}

.card-wrapper {
  width: 100vw;
  height: calc(constant(safe-area-inset-bottom) + 187px);
  height: calc(env(safe-area-inset-bottom) + 187px);
  position: fixed;
  bottom: 0;
  box-shadow: 0 -3px 3px 0 rgba(34, 34, 34, 0.2);
  padding: 20px 15px 0px 15px;
  box-sizing: border-box;
  transform: translateZ(1);
  animation: fade-in 0.3s ease-in-out;
  will-change: transform;
  transform: translateZ(0);
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translate3d(0, 187px, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0px, 0);
  }
}

.full-slide-up-leave-active {
  transition: all 0.3s ease-in-out;
  transform: translate3d(0, 0, 0);
}

.full-slide-up-leave-to {
  transform: translate3d(0, 187px, 0);
}

.card-text {
  margin-bottom: 14px;
}
</style>
